import { DraftClasses } from './classes/DraftClasses';
import { DraftComponents } from './components/DraftComponents';
import { registry, traitRegistry, valueRegistry } from '../../registry/Registry';
import { DraftSkeletons } from './skeletons/DraftSkeletons';
import { TraitRegistryDraft } from './traits/TraitRegistryDraft';
import { ValueRegistryDraft } from './values/ValueRegistryDraft';
export class PackageDraft {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    classes = new DraftClasses();
    components = new DraftComponents();
    skeletons = new DraftSkeletons(registry.skeletonRegistry);
    traits = new TraitRegistryDraft(traitRegistry);
    values = new ValueRegistryDraft(valueRegistry);
}
